import React, {useEffect} from "react";
import Head from 'next/head'
import supportsWebP from 'supports-webp';
import AOS from "aos";
import {useRouter} from "next/router";
import {Toaster} from "react-hot-toast";

export default function MainLayout(
    {
        children,
        title,
        alternate,
        description,
        keywords,
        page,
        loaded,
        schemaData,
        organizationSchemaData,
        webSiteSchemaData,
        canonical
    }) {

    const router = useRouter();

    const getBaseUrl = () => {
        return process.env.NEXT_PUBLIC_SITE_URL
    }

    useEffect(() => {

        supportsWebP.then(supported => {
            if (supported) {
                document.body.classList.add('webp')
            }
        });
    }, [])

    useEffect(() => {
        if (loaded) {
            AOS.init({
                once: true
            });
        }
    }, [loaded])

    return (
        <>
            <Head>
                <title>{title}</title>

                <link rel="icon" type="image/svg+xml" href="/favicon.svg" sizes="any"/>
                <link rel="icon" href="/favicon.png" type="image/png" sizes="32x32"/>
                <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96"/>
                <link rel="shortcut icon" type="image/x-icon" href="/favicon.ico" sizes="48x48"/>
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
                <link rel="manifest" href="/site.webmanifest"/>
                <meta name="msapplication-TileColor" content="#ffffff"/>
                <meta name="apple-mobile-web-app-title" content="HFDX"/>
                <meta name="application-name" content="HFDX"/>
                <meta name="theme-color" content="#ffffff"/>

                <meta name="robots"
                      content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"/>

                {description && <meta name="description" content={description}/>}
                {keywords && <meta name="keywords" content={keywords}/>}

                <link rel="canonical"
                      href={canonical ? `${getBaseUrl()}${canonical}` : `${getBaseUrl()}${router.asPath}`}/>
                {router.locales.map(locale => {
                    if (locale === 'en') {
                        return <link key={locale} rel="alternate" hrefLang="en"
                                     href={alternate ? `${getBaseUrl()}/${alternate}` : `${getBaseUrl()}`}/>
                    } else {
                        return <link key={locale} rel="alternate" hrefLang={locale}
                                     href={alternate ? `${getBaseUrl()}/${locale}/${alternate}` : `${getBaseUrl()}/${locale}`}/>
                    }
                })}
                <link rel="alternate" hrefLang="x-default"
                      href={alternate ? `${getBaseUrl()}/${alternate}` : `${getBaseUrl()}`}/>
                <meta property="og:url" content={getBaseUrl()}/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content={title}/>
                <meta property="og:description" content={description}/>
                <meta property="og:image" content={`${getBaseUrl()}/og.png`}/>

                <meta name="twitter:card" content="summary_large_image"/>
                <meta property="twitter:domain" content={getBaseUrl()}/>
                <meta property="twitter:url" content={getBaseUrl()}/>
                <meta name="twitter:title" content={title}/>
                <meta name="twitter:description" content={description}/>
                <meta name="twitter:image" content={`${getBaseUrl()}/og.png`}/>

                {schemaData &&
                    <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(schemaData)}}/>}
                {organizationSchemaData && <script type="application/ld+json"
                                                   dangerouslySetInnerHTML={{__html: JSON.stringify(organizationSchemaData)}}/>}
                {webSiteSchemaData && <script type="application/ld+json"
                                                   dangerouslySetInnerHTML={{__html: JSON.stringify(webSiteSchemaData)}}/>}

            </Head>
            <div className={page}>
                {children}
                <Toaster/>
            </div>
        </>
    )
}